import { useEffect } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import "./Table.css";
import FilterAndSortMenu from "./FilterandSortMenu";

const TablaMRT = ({ columns, data, options = {}, onTableReady }) => {
  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyCellProps: {
      sx: {
        fontFamily: "Nunito, regular",
        fontSize: "14px",
      },
    },
    muiTableProps: { sx: { tableLayout: "fixed" } },

    // ...otras opciones
    enableColumnFilterModes: true,
    enableColumnOrdering: false,
    enableColumnPinning: false,
    enableSelectAll: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableGlobalFilter: true,
    globalFilterFn: "includesString",
    positionActionsColumn: "rigth",
    enableHighlightSearchMatches: true,
    enableSorting: true,
    enableColumnActions: true,
    localization: MRT_Localization_ES,
    renderColumnActionsMenuItems: ({ column, closeMenu }) => [
      <FilterAndSortMenu key="menu" column={column} closeMenu={closeMenu} />,
    ],
    ...options,
  });

  useEffect(() => {
    if (onTableReady) {
      onTableReady(table);
    }
  }, [table, onTableReady]);

  return <MaterialReactTable table={table} />;
};

export default TablaMRT;
